export default __webpack_public_path__ + "static/media/plain-sticker-wh.527f2b29.png";